import type { TickSystem } from '@app-games/core';
import type { GameState } from '../state.js';
import type { GameAction } from '../actions.js';

export const playTimeSystem: TickSystem<GameState, GameAction> = {
  name: 'playTime',
  update: (state, dt, _dispatch) => {
    if (!state.isRunning) return state;
    return {
      ...state,
      playTime: state.playTime + dt,
      lastSaveTimestamp: Date.now(),
    };
  },
};
